// 30s delay (30000ms)
export const DEFAULT_QUERY_REFRESH_INTERVAL = 31 * 1000;
// 5s delay (5000ms)
export const TOAST_TIMEOUT = 5 * 1000;
export const MINA_COIN_INDEX = 12586;
// 30s delay
export const DEFAULT_REFRESH_COUNTDOWN = 31;
// 10s delay (10000ms)
export const UPDATE_WALLET_ID_TIMEOUT = 1 * 1000;
